export enum CustomFieldAppliesTo {
  RFQ = 'rfq',
  SHIPMENT = 'shipment',
  CONTAINER = 'container',
}

export enum CustomFieldType {
  TEXT = 'text',
  NUMBER = 'number',
  DATE = 'date',
  CHECKBOX = 'checkbox',
  SELECT = 'select',
}

export enum CustomFieldSuppliedBy {
  CUSTOMER = 'customer',
  AI = 'ai',
  BOTH = 'both',
}